import { useEffect, useState } from "react";
import { Footer } from "../components/Footer";
import { Hero } from "../components/Hero";
import { Category } from "../components/Main/Category";
import { FeaturedListing } from "../components/Main/FeaturedListings";
import { HowItWorks } from "../components/Main/HowItWorks";
import { JoinNow } from "../components/Main/JoinNow";
import { Navbar } from "../components/Navbar";
import { ChatButton } from "../components/ChatButton";
import { ShareNow } from "../components/Main/ShareNow";
import { useAuth } from "../contexts/AuthContext";
import { useLocation } from "react-router-dom";

const Index = () => {
  const [isContentVisible, setIsContentVisible] = useState(false);
  const { isAuthenticated } = useAuth();
  const location = useLocation()

  // To scroll to how it works when clicked in navbar
  useEffect(() => {
    if (location.state?.scrollTo === "how-it-works") {
      const el = document.getElementById("how-it-works");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  useEffect(() => {
    // Animation trigger for main content sections
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsContentVisible(true);
          }
        });
      },
      { threshold: 0.1 }
    );

    const target = document.getElementById("main-content");
    if (target) observer.observe(target);

    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />

      {/* ChatBox */}
      <ChatButton />

      {/* Hero Section - handles its own animation */}
      <Hero />

      {/* Main Content */}
      <main
        id="main-content"
        className={`flex-1 py-20 transition-all duration-1000 ${
          isContentVisible
            ? "opacity-100 translate-y-0"
            : "opacity-0 translate-y-10"
        }`}
      >
        <div className="container px-4 mx-auto">
          <HowItWorks />
          <FeaturedListing />
          <Category />
          {isAuthenticated ? <ShareNow /> : <JoinNow />}
        </div>
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default Index;
